module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (36).c8a55667.jpg";